import { dispatchCustomEvent } from "./dispatchCustomEvent";
import { getRandomId } from "./getRandomId";
export const NOTIFICATION_CUSTOM_EVENT_NAME = "NOTIFICATION_CUSTOM_EVENT_NAME";
export const DEFAULT_DURATION = 1500;
export const sendNotification = ({ id = getRandomId(), content, durationInMS = DEFAULT_DURATION, }) => {
    dispatchCustomEvent(NOTIFICATION_CUSTOM_EVENT_NAME, {
        canBeCancelled: false,
        bubble: false,
        detail: {
            id,
            durationInMS,
            content,
        },
    });
    return id;
};
//# sourceMappingURL=sendNotification.js.map